import { render, staticRenderFns } from "./AudiologyKpis.vue?vue&type=template&id=345a7844&"
import script from "./AudiologyKpis.vue?vue&type=script&lang=js&"
export * from "./AudiologyKpis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('345a7844')) {
      api.createRecord('345a7844', component.options)
    } else {
      api.reload('345a7844', component.options)
    }
    module.hot.accept("./AudiologyKpis.vue?vue&type=template&id=345a7844&", function () {
      api.rerender('345a7844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/AudiologyKpis.vue"
export default component.exports